module.exports = __webpack_public_path__ + "img/live-person-light.5f42ef4b.svg";